'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const groupPackagesForUI = shipments => {
  const {
    groupedEligibleShipments,
    groupedIneligibleShipments
  } = (shipments ?? []).reduce((acc, shipment) => {
    const {
      eligibleItems,
      ineligibleItems
    } = shipment.items.reduce((accc, item) => {
      var _item$evaluatedEligib;
      if (!((_item$evaluatedEligib = item.evaluatedEligibility) !== null && _item$evaluatedEligib !== void 0 && _item$evaluatedEligib.isEligible)) {
        return {
          eligibleItems: accc.eligibleItems,
          ineligibleItems: [...accc.ineligibleItems, item]
        };
      } else {
        return {
          eligibleItems: [...accc.eligibleItems, item],
          ineligibleItems: accc.ineligibleItems
        };
      }
    }, {
      eligibleItems: [],
      ineligibleItems: []
    });
    return {
      groupedEligibleShipments: eligibleItems.length > 0 ? [...acc.groupedEligibleShipments, {
        ...shipment,
        items: eligibleItems
      }] : acc.groupedEligibleShipments,
      groupedIneligibleShipments: ineligibleItems.length > 0 ? [...acc.groupedIneligibleShipments, {
        ...shipment,
        items: ineligibleItems
      }] : acc.groupedIneligibleShipments
    };
  }, {
    groupedEligibleShipments: [],
    groupedIneligibleShipments: []
  });
  return {
    groupedEligibleShipments,
    groupedIneligibleShipments
  };
};

exports.groupPackagesForUI = groupPackagesForUI;
